import { render, staticRenderFns } from "./nofound.vue?vue&type=template&id=0d7aeaaf&"
import script from "./nofound.vue?vue&type=script&lang=js&"
export * from "./nofound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports